import {
  RECOVERY_TOKEN,
  RECOVERY_MESSAGES,
  RECOVERY_PASSWORD_UPDATE,
  RECOVERY_PASSWORD_VINCULADO_UPDATE,
  RECOVERY_USUARIO_VINCULADO_SEND
} from "../actions/recuperarSenha";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const state = {};

const getters = {};

const actions = {
  [RECOVERY_TOKEN]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.recovery
        .recoveryToken(payload.token)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [RECOVERY_MESSAGES]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.recovery
        .recoveryMessages(
          payload.idfornecedor,
          payload.cliente,
          payload.recoveryClass
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [RECOVERY_PASSWORD_UPDATE]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.recovery
        .recoveryPassword(payload.token, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [RECOVERY_PASSWORD_VINCULADO_UPDATE]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.recovery
        .recoveryPasswordVinculado(payload.token, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [RECOVERY_USUARIO_VINCULADO_SEND]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.recovery
        .recuperarSenhaUsuarioVinculado(
          payload.idcadastroextracliente,
          payload.idfornecedor,
          payload.idusuario
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
